import styled from 'styled-components';
import { CssFuncs } from '../../../foundation/css/css.funcs';

const Container = styled.div.withConfig({
  componentId: 'node-item-action-snooze_container',
  displayName: 'NodeItemActionSnooze.Container',
})`
  ${CssFuncs.css.size({ xy: '18px' })}
  border-radius: 4px;

  ${CssFuncs.css.alignCenter()}

  user-select: none;
  cursor: pointer;

  background-color: #472268d7;
  color: #9447d7;
`;

export const NodeItemActionSnoozeStyle = {
  Container,
};
